// CREDENTIALS FORM
export const TOGGLE_CREDENTIALS_FORM = "TOGGLE_CREDENTIALS_FORM";
export const CREDENTIALS_FORM_DATA = "CREDENTIALS_FORM_DATA";
export const IS_VALID_CREDENTIALS_FORM = "IS_VALID_CREDENTIALS_FORM";

// SNACKBAR NOTIFIER
export const SNACKBAR_NOTIFIER = "SNACKBAR_NOTIFIER";